import {Inject, Injectable} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {FirebaseApp} from 'angularfire2';
import {AuthService} from './auth.service';
import {Device} from '../classes/device';
import * as firebase from 'firebase';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class DeviceService {
  private sdkDb: any;
  private userId: string = null;
  private userType: string = null;

  constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp, private authService: AuthService) {
    console.log('device service called')
    this.sdkDb = fb.database();
    this.authService.getCurrentUser().subscribe(user => {
      if  (user) {
        console.log('user received', user);
        this.userId = user.uid;
      } else {
        this.userId = null;
      }
    });
    this.authService.getUserType().subscribe(type => {this.userType = type; });
  }

  getAllDevices() {
    let devicesRef = null;
    if (this.userType === 'admin') {
      devicesRef = `devices/nuresp`;
    } else if (this.userType === 'partner') {
      devicesRef = `devices/partners/${this.userId}`;
    }
    console.log('devicesRef', devicesRef);
    return this.db.list(devicesRef).snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });
  }

  addNewDevice(device: Device): Promise<any> {
    if (this.userType === 'admin') {
      console.log('aaaaaaaa received');
      return this.sdkDb.ref(`devices/nuresp/`).orderByChild('serial').equalTo(device.serial).once('value')
        .then(data => {
          console.log('device service called')
          if (data.val()) {
            return Promise.reject('exist');
          } else {
              device.creationDate = firebase.database.ServerValue.TIMESTAMP;
              const newDeviceKey = this.db.createPushId();
              device.key = newDeviceKey;
              return this.db.object(`devices/nuresp//${newDeviceKey}/`).set(device);
          }

        }).catch(err => {return Promise.resolve('exist'); });



    //   device.creationDate = firebase.database.ServerValue.TIMESTAMP;
    //   const newDeviceKey = this.db.createPushId();
    //   device.key = newDeviceKey;
    //   return this.db.object(`devices/nuresp//${newDeviceKey}/`).set(device);
    // } else {
    //   return Promise.reject('Não Admin')
    } else {
      return Promise.reject('auth');
    }
  }
  getUserType() {
    return this.userType;
  }
  getAvaliableDevices() {
    let dbRef = null;
    if (this.userType === 'admin') {
      dbRef = 'devices/nuresp';
    } else {
      dbRef = `devices/partners/${this.userId}`;
    }
    return this.db.list(dbRef, ref => ref.orderByChild('allocatedTo').equalTo('')).valueChanges();
  }
  getDevice(deviceSerial: string) {
    let devicesRef = null;
    if (this.userType === 'admin') {
      devicesRef = `devices/nuresp`;
    } else if (this.userType === 'partner') {
      devicesRef = `devices/partners/${this.userId}`;
    }
    return this.db.list<Device>(devicesRef, ref => ref.orderByChild('serial').equalTo(deviceSerial)).valueChanges();
  }
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/services/device.service.ts